<template>
<div>
    <h1 class="subtitle">Transferencias e Ingresos</h1>
    <div class="nj-panel">
        <div class="nj-panel-content">
            <div class="nj-grid">
                <InputSelect InputSelect label="Tipos de transferencia" v-model="filters.tfi_tipo" :source="tipos" itemKey="tit_id" itemValue="tit_id" itemFilter="tit_nombre"
                    :labelFunction="(item) => item.tit_nombre" @selectItem="seleccionarTipoBusqueda">
                </InputSelect>
                <InputSelect InputSelect label="Estados" v-model="filters.est_codigo" :source="estados" itemKey="est_codigo" itemValue="est_codigo" itemFilter="est_nombre"
                    :labelFunction="(item) => item.est_nombre">
                </InputSelect>
                <template v-if="busquedaOrden">
                    <div>
                        <div class="nj-label">Orden</div>
                        <input type="text" class="nj-text nj-date" v-model="filters.ord_code">
                    </div>
                </template>
                <template v-if="busquedaEntreAlmacenes">
                    <InputSelect label="Almacen origen" v-model="filters.alm_origen" :source="almacenes_origen" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacen"
                        :labelFunction="labelAlmacen">
                    </InputSelect>
                </template>
                <InputSelect label="Almacen destino" v-model="filters.alm_destino" :source="almacenes_destino" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacen"
                    :labelFunction="labelAlmacen"
                    @selectItem="buscar()">
                </InputSelect>
                <div class="nj-flex">
                    <InputDate label="Fechas" v-model="filters.fecha_inicio_date" @input="buscar()"></InputDate>
                    <InputDate v-model="filters.fecha_fin_date" @input="buscar()"></InputDate>
                </div>
            </div>
            <br>
            <div class="nj-flex">
                <Button icon="search" label="Buscar" @click="buscar()"></Button>
                <Button icon="doc" label="Orden compra" @click="popup({ interfaz: 'TransferenciaOrdenCompra', activar: true })" activationCode="registrar_transferencia_orden_compra"></Button>
                <!-- // * se esta desactivando la opcion "compra externa " para el presente proyecto. -->
                <!-- // * a toda "compra externa" se le esta generando una "orden de compra" -->
                <Button icon="cart" label="Compra externa" @click="popup({ interfaz: 'TransferenciaCompraExterna', activar: true })"></Button>
                <Button icon="transfer" label="Entre almacenes" @click="popup({ interfaz: 'TransferenciaEntreAlmacenes', activar: true })"></Button>
            </div>
            <br>
            <b-table :data="transferencias" :paginated="true" :per-page="10" current-page.sync="1" :pagination-simple="false" pagination-position="bottom" default-sort-direction="asc"
                :pagination-rounded="false"
                sort-icon="arrow-up" sort-icon-size="is-small" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                <template slot-scope="props">
                    <b-table-column label="ID" header-class="is-info">{{ props.row.tfi_id }}</b-table-column>
                    <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.emp_nombre }} {{ props.row.tfi_fecha_registro }}</b-table-column>
                    <b-table-column label="Registrado por" header-class="is-info">{{ props.row.tfi_usu_registrador_nombre }}</b-table-column>
                    <b-table-column label="Tipo de transferencia" header-class="is-info">{{ showTipoTransferencia(props.row) }}</b-table-column>
                    <b-table-column label="Almacen destino" header-class="is-info">{{ props.row.alm_destino_nombre }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-field>
                            <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                        </b-field>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <Button type="icon" icon="info" title="Ver detalle" @click="openTransferenciaView(props.row.tfi_id)"></Button>
                            <Button type="icon" icon="review" title="Confirmar ingreso" :activation="habilitarIngreso(props.row)" @click="openIngreso(props.row.tfi_id)"></Button>
                            <Button type="icon" icon="delete" title="Eliminar" :activation="habilitarEliminar(props.row)" @click="eliminar(props.row.tfi_id)"></Button>
                            <Button type="icon" icon="pdf" title="Generar Orden Ingreso" @click="generarOrdenIngreso(props.row.tfi_id)"></Button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <!-- -------------------------------------------------------------------------------- -->
    <TransferenciaOrdenCompra v-if="showTransferenciaOrdenCompra" @close="popup($event)"></TransferenciaOrdenCompra>
    <TransferenciaCompraExterna v-if="showTransferenciaCompraExterna" @close="popup($event)"></TransferenciaCompraExterna>
    <TransferenciaEntreAlmacenes v-if="showTransferenciaEntreAlmacenes" @close="popup($event)"></TransferenciaEntreAlmacenes>
    <TransferenciaItemsView v-if="activarTransferencia" @close="closePopups($event)" :tfi_id="tfi_id"></TransferenciaItemsView>
    <TransferenciaItemsIngreso v-if="activarIngreso" @close="closePopups($event)" :tfi_id="tfi_id"></TransferenciaItemsIngreso>
    <vue-html2pdf :preview-modal="pdfTesting" false-download="!pdfTesting" false-layout="false" :float-layout="true" :filename="pdf_file_name" :pdf-quality="2" :manual-pagination="true"
        pdf-format="a4"
        :paginate-elements-by-height="1400" pdf-orientation="portrait" pdf-content-width="100%" ref="pdf">
        <template v-if="transferencia_items" slot="pdf-content">
            <!-- -->
            <div class="band">
                <img style="width: 100px; height: auto;" src="../../assets/logo.png" alt="logo">
                <div class="pdf-title">Orden de Ingreso Almacén: {{ transferencia_items.tfi_codigo }}</div>
            </div>
            <div class="band">
                <div class="nj-card">
                    <div class="nj-grid">
                        <LabelGroup label="Tipo transferencia" :value="transferencia_items.tfi_tipo_nombre"></LabelGroup>
                        <LabelGroup label="Orden de compra" :value="transferencia_items.ord_code" v-if="isOrdenCompra"></LabelGroup>
                        <LabelGroup label="Guia Remisión" :value="transferencia_items.tfi_guia_remision" v-if="isEntreAlmacenes"></LabelGroup>
                        <LabelGroup label="Almacen origen" :value="transferencia_items.alm_origen_nombre" v-if="isEntreAlmacenes"></LabelGroup>
                        <LabelGroup label="Almacen destino" :value="transferencia_items.alm_destino_nombre"></LabelGroup>
                        <LabelGroup label="Transferido por" :value="transferencia_items.tfi_usu_registrador_nombre"></LabelGroup>
                        <LabelGroup label="Fecha envio" :value="transferencia_items.tfi_fecha_registro"></LabelGroup>
                        <LabelGroup label="Fecha recepción" :value="transferencia_items.tfi_fecha_ingreso"></LabelGroup>
                        <LabelGroup label="Recepcionado por" :value="transferencia_items.tfi_usu_recepcionador_nombre"></LabelGroup>
                        <LabelGroup label="Orden de ingreso almacén" :value="transferencia_items.tfi_codigo"></LabelGroup>
                    </div>
                </div>
            </div>
            <!-- html2pdf__page-break -->
            <div id="items"></div>
            <div class="band">
                <div class="sign-box-content ">
                    <div class="sign-box">
                        <div class="sign-box-img-container">
                            <img class="sign-box-img" src="../../assets/3.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 3">
                            <img class="sign-box-img" src="../../assets/39.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 39">
                            <img class="sign-box-img" src="../../assets/106.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 106">
                            <img class="sign-box-img" src="../../assets/189.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 189">
                            <img class="sign-box-img" src="../../assets/202.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 202">
                            <img class="sign-box-img" src="../../assets/204.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 204">
                            <img class="sign-box-img" src="../../assets/205.jpg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 205">
                            <img class="sign-box-img" src="../../assets/216.jpeg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 216">
                            <img class="sign-box-img" src="../../assets/203.jpeg" alt="firma" v-if="transferencia_items.tfi_usu_registrador == 203">
                        </div>
                        <div class="sign-box-cargo">Jefe Logística</div>
                        <div class="sign-box-nombre">
                            {{ transferencia_items.tfi_usu_registrador_nombre }}
                        </div>
                    </div>
                    <div class="sign-box">
                        <div class="sign-box-img-container">
                            <img class="sign-box-img" src="../../assets/3.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 3">
                            <img class="sign-box-img" src="../../assets/39.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 39">
                            <img class="sign-box-img" src="../../assets/106.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 106">
                            <img class="sign-box-img" src="../../assets/189.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 189">
                            <img class="sign-box-img" src="../../assets/202.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 202">
                            <img class="sign-box-img" src="../../assets/204.jpg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 204">
                            <img class="sign-box-img" src="../../assets/216.jpeg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 216">
                            <img class="sign-box-img" src="../../assets/203.jpeg" alt="firma" v-if="transferencia_items.tfi_usu_recepcionador == 203">
                        </div>
                        <div class="sign-box-cargo">Jefe Almacén</div>
                        <div class="sign-box-nombre">
                            {{ transferencia_items.tfi_usu_recepcionador_nombre }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </vue-html2pdf>
</div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf"
import { EstadoEnum, TipoTransferenciaEnum } from "../../constants"
import { LabelService, ResponseStatus, TransferenciaItemsService, UsuarioService } from "../../services"
import OpcionesService from "../../services/OpcionesService"
import { Confirm } from "../../util"
import Toast from "../../util/toast"
import { Button, InputDate, InputSelect, LabelGroup } from "../components"
import TransferenciaCompraExterna from "./TransferenciaCompraExterna"
import TransferenciaEntreAlmacenes from "./TransferenciaEntreAlmacenes"
import TransferenciaItemsIngreso from "./TransferenciaItemsIngreso"
import TransferenciaItemsView from "./TransferenciaItemsView"
import TransferenciaOrdenCompra from "./TransferenciaOrdenCompra"

export default {
    name: "TransferenciaItems",
    components: {
        TransferenciaCompraExterna,
        TransferenciaEntreAlmacenes,
        TransferenciaOrdenCompra,
        TransferenciaItemsView,
        TransferenciaItemsIngreso,
        Button,
        InputDate,
        InputSelect,
        LabelGroup,
        VueHtml2pdf,
    },
    data() {
        return {
            filters: {
                tfi_tipo: null,
                est_codigo: null,
                alm_destino: null,
                fecha_inicio_date: null,
                fecha_fin_date: null,
                fecha_inicio: null,
                fecha_fin: null,
                fecha_inicio: null,
                fecha_fin: null,
            },
            transferencias: [],
            estados: [],
            tipos: [],
            almacenes_origen: [],
            almacenes_destino: [],
            tfi_id: null,
            activarOrdenCompra: false,
            activarEntreAlmacenes: false,
            activarCompraExterna: false,
            activarTransferencia: false,
            activarIngreso: false,
            showTransferenciaOrdenCompra: false,
            showTransferenciaEntreAlmacenes: false,
            showTransferenciaCompraExterna: false,
            busquedaOrden: false,
            busquedaEntreAlmacenes: false,
            pdf_file_name: null,
            transferencia_items: null,
            htmlToPdfOptions: null,
            pdfTesting: false
        }
    },
    computed: {
        isOrdenCompra() {
            return this.transferencia_items.tfi_tipo == TipoTransferenciaEnum.ORDEN_COMPRA.tit_id
        },
        isEntreAlmacenes() {
            return this.transferencia_items.tfi_tipo == TipoTransferenciaEnum.ENTRE_ALMACENES.tit_id
        },
        recepcionador() {
            return UsuarioService.getUsuario().usu_nombre_completo
        }
    },
    methods: {
        isCorporative() {
            return UsuarioService.isCoorporative()
        },
        buscar() {
            this.transferencias = []
            // cambiar...
            // this.filters.fecha_inicio = DateTime.parseDateToString(this.filters.fecha_inicio_date)
            // this.filters.fecha_fin = DateTime.parseDateToString(this.filters.fecha_fin_date)
            TransferenciaItemsService.buscar(this.filters).then(
                response => {
                    this.transferencias = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        labelAlmacen(item) {
            return LabelService.almacen(item)
        },
        filterAlmacen(items, param) {

        },
        tagEstado(id) {
            return EstadoEnum.Tag(id)
        },
        popup({
            interfaz,
            activar,
            buscar,
            tfi_id,
        }) {
            switch (interfaz) {
                case "TransferenciaOrdenCompra":
                    this.showTransferenciaOrdenCompra = activar
                    break
                case "TransferenciaEntreAlmacenes":
                    this.showTransferenciaEntreAlmacenes = activar
                    break
                case "TransferenciaCompraExterna":
                    this.showTransferenciaCompraExterna = activar
                    break
            }
            if (buscar) {
                this.buscar()
            }
            if (tfi_id) {
                this.tfi_id = tfi_id
            }
        },
        openPopup(view) {
            switch (view) {
                case "activarOrdenCompra":
                    this.activarOrdenCompra = true
                    break
                case "activarEntreAlmacenes":
                    this.activarEntreAlmacenes = true
                    break
                case "activarCompraExterna":
                    this.activarCompraExterna = true
                    break
            }
        },
        openTransferenciaView(tfi_id) {
            this.tfi_id = tfi_id
            this.activarTransferencia = true
        },
        openIngreso(tfi_id) {
            this.tfi_id = tfi_id
            this.activarIngreso = true
        },
        closePopups(condition) {
            this.activarOrdenCompra = false
            this.activarEntreAlmacenes = false
            this.activarCompraExterna = false
            this.activarTransferencia = false
            this.activarIngreso = false
            this.tfi_id = null
            if (condition) {
                this.buscar()
            }
        },
        eliminar(tfi_id) {
            Confirm.show({
                message: "¿Esta seguro de eliminar la transferencia?",
                action: () => {
                    TransferenciaItemsService
                        .eliminar({
                            tfi_id
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscar()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        habilitarIngreso(item) {
            return item.est_codigo == EstadoEnum.CREADO.est_codigo && item.tfi_tipo != TipoTransferenciaEnum.COMPRA_EXTERNA.tit_id
        },
        habilitarEliminar(item) {
            const usuario = UsuarioService.getUsuario()
            if (usuario.usu_nivel == 1) {
                return item.est_codigo == EstadoEnum.CREADO.est_codigo
            }
            else {
                return item.est_codigo == EstadoEnum.CREADO.est_codigo
                    && item.tfi_usu_registrador == usuario.usu_id
            }
        },
        showTipoTransferencia(item) {
            if (item.tfi_tipo == TipoTransferenciaEnum.ORDEN_COMPRA.tit_id) {
                return `${item.tfi_tipo_nombre} | ${item.ord_code}`
            } else {
                return item.tfi_tipo_nombre
            }
        },
        seleccionarTipoBusqueda() {
            this.filters.ord_code = null
            this.filters.alm_origen = null
            this.filters.ord_code = null
            this.busquedaOrden = false
            this.busquedaEntreAlmacenes = false
            if (this.filters.tfi_tipo == TipoTransferenciaEnum.ORDEN_COMPRA.tit_id) {
                this.busquedaOrden = true
                this.buscar()
            }
            else if (this.filters.tfi_tipo == TipoTransferenciaEnum.ENTRE_ALMACENES.tit_id) {
                this.filters.alm_origen = ""
                this.busquedaEntreAlmacenes = true
                this.buscar()
            }
            else if (this.filters.tfi_tipo == TipoTransferenciaEnum.COMPRA_EXTERNA.tit_id) {
                this.buscar()
            }
        },
        generarOrdenIngreso(tfi_id) {
            TransferenciaItemsService
                .obtener({
                    transferencia_items: {
                        tfi_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        const maxRow = 18
                        this.transferencia_items = response.data
                        this.pdf_file_name = this.transferencia_items.tfi_codigo
                        const items = this.transferencia_items.lista_transferencia_items_detalle
                        // * determinando la cantidad de iteraciones
                        const iteraciones = Math.ceil(items.length / maxRow)
                        let groups = []
                        // * obteniendo los grupos de items a construir
                        let pos_inicial = 0
                        let pos_final = 0
                        for (let i = 0; i < iteraciones; i++) {
                            pos_inicial = pos_final
                            pos_final = pos_inicial + maxRow
                            groups.push(items.slice(pos_inicial, pos_final))
                        }
                        // * construyendo las tablas
                        let numRow = 1
                        let template = ""
                        groups.forEach((group, index) => {
                            let detail = ""
                            group.forEach(item => {
                                detail +=
                                    `<div>${numRow}</div>
                                    <div>${item.prv_nombre}</div>
                                    <div>${item.tid_cantidad}</div>
                                    <div>${item.tid_ingreso_cantidad}</div>
                                    <div>${item.tid_ingreso_notas != null ? item.tid_ingreso_notas : '-'}</div>`
                                numRow++
                            })
                            let next = index < (groups.length - 1) ? "html2pdf__page-break" : " "
                            template +=
                                `<div class="${next}">
                                    <div style="padding: 8px 12px">
                                        <div class="nj-card">
                                            <div class="data-grid">
                                                <div class="data-grid-title" style="grid-template-columns: 40px 1fr 80px 80px 100px;">
                                                    <div>N°</div>
                                                    <div>Producto</div>
                                                    <div>Cantidad enviada</div>
                                                    <div>Cantidad ingresada</div>
                                                    <div>Notas</div>
                                                </div>
                                                <div class="data-grid-row" style="grid-template-columns: 40px 1fr 80px 80px 100px;">
                                                    ${detail}
                                                </div>
                                            </div>
                                        </div>
                                    </div>   
                                </div>`
                        })
                        setTimeout(() => {
                            document.getElementById("items").innerHTML = template
                        }, 1000)
                        this.printPdf()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        printPdf() {
            setTimeout(() => {
                this.$refs.pdf.generatePdf()
            }, 1000)
        }
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        OpcionesService
            .getOpciones({
                estado: {
                    modulo: "transferenciasItems"
                },
                almacen: {
                    pry_id: UsuarioService.getProject()
                },
                tipo_transferencia: {},
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = response.data.estados
                    this.filters.est_codigo = EstadoEnum.CREADO.est_codigo
                    this.almacenes_origen = response.data.almacenes
                    this.almacenes_destino = response.data.almacenes
                    this.tipos = response.data.tipos_transferencia
                    this.filters.tfi_tipo = 1
                    this.seleccionarTipoBusqueda()
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped>
.band {
    padding: 8px 12px;
}

.pdf-title {
    font-size: 16px;
}

.sign-box-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    width: 390px;
    margin: 0 auto;
}

.sign-box {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 30px 30px;
}

.sign-box-img-container {
    display: flex;
    gap: 0;
    align-items: end;
}

.sign-box-img {
    margin: 0 0 12px 0;
}

.sign-box-cargo {
    border-top: 1px solid #333;
    text-align: center;
    padding: 6px 0 0 0;
}

.sign-box-nombre {
    text-align: center;
    font-weight: bold;
}
</style>